import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import Liveness from './views/Liveness';
import { ApplicationProvider, createDependencies } from './context';

function App() {
  return (
    <ApplicationProvider dependencies={createDependencies()}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Liveness />} />
        </Routes>
      </BrowserRouter>
    </ApplicationProvider>
  )
}

export default App;
